import { ClientEventModel } from "@/api/model";
import type { CuraiMessageTypes } from "@/conversation/CuraiMessage";
import CuraiMessage from "@/conversation/CuraiMessage";
import UserMessage from "@/conversation/UserMessage";
import { captureMessage } from "@/sentry";

export default function CuraiMessageStream({
  messages,
}: {
  messages: ClientEventModel[];
}) {
  return (
    <>
      {messages?.map((message) => {
        const {
          id,
          content,
          role,
          type,
          senderPhotoUrl,
          senderFullNameWithTitle,
        } = message;

        if (role === "user") {
          if (!Array.isArray(content)) {
            captureMessage(
              `Unsupported content type ${typeof content} found while rendering user message.`,
            );
            return null;
          }
          return (
            <UserMessage
              key={message.clientId ?? id}
              message={content}
              conversationType="curai"
              messageId={id}
            />
          );
        } else if (role === "clinician" || role === "system") {
          return (
            <CuraiMessage
              key={id}
              content={content as string}
              type={type as CuraiMessageTypes}
              messageId={id}
              senderPhotoUrl={senderPhotoUrl}
              senderFullNameWithTitle={senderFullNameWithTitle}
            />
          );
        }
        return null;
      })}
    </>
  );
}
